import { publicModuleBase, publicStorageKey } from '@sad5/contracts';
export type ThemePreference = 'dark' | 'light' | 'system';

const storageKey = publicStorageKey(
  'portal',
  publicModuleBase('portal', import.meta.env.BASE_URL),
  'sad5.theme',
);

export function readTheme(): ThemePreference {
  const stored = localStorage.getItem(storageKey);
  return stored === 'dark' || stored === 'light' || stored === 'system'
    ? stored
    : 'system';
}

export function applyTheme(theme: ThemePreference): void {
  if (theme === 'system')
    document.documentElement.removeAttribute('data-theme');
  else document.documentElement.dataset.theme = theme;
  localStorage.setItem(storageKey, theme);
}

export function applyStoredTheme(): void {
  applyTheme(readTheme());
}
